<template>
  <div class="d-search-results-group">
    <strong>{{ resultsGroup.title }}</strong>

    <ul>
      <DSearchResult
        v-for="result in resultsGroup.entries"
        :key="`${ resultsGroup.type }-${ result.id }`"
        :result="result"
        :title="result.label"
        :result-type="resultsGroup.type"
      />
    </ul>
  </div>
</template>

<script>
import DSearchResult from './d-search-result/d-search-result.vue';

export default {
  components: {
    DSearchResult,
  },
  props: {
    resultsGroup: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-search-results-group {
  strong {
    color: getColor($grey, dark);
    display: block;
    padding: $_1em 0;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      display: block;
      padding: 0;
    }
  }
}
</style>
